import { ClassConstructor, plainToClass } from 'class-transformer';

class ChannelSubscriber<P> {
  private readonly handler: (event: CustomEvent<P>) => void;

  constructor(
    private eventName: string,
    private payloadModel: ClassConstructor<P>,
    handler: (payload: P) => void
  ) {
    this.handler = (event: Event): void => {
      const detail = ChannelSubscriber.extractDetail(event);
      const payload = plainToClass<P, {}>(this.payloadModel, detail);
      handler(payload);
    };

    this.handler.bind(this);

    window.addEventListener(this.eventName, this.handler as EventListener);
  }

  public stop(): void {
    window.removeEventListener(this.eventName, this.handler as EventListener);
  }

  private static extractDetail(event: Event): Record<string, never> {
    const detail = (event as CustomEvent).detail || {};
    const isObj = detail instanceof Object && !(detail instanceof Array);
    if (isObj) {
      return detail;
    }
    throw new Error('Event detail must be an object and can not be an array!');
  }
}
export default ChannelSubscriber;
